const InspectMasterModel = require("@/appModel/InspectMaster/InspectMasterModel")
const InspectPlaceModel = require("@/appModel/InspectPlace/InspectPlaceModel")
const RecentlyModel = require("@/appModel/Recently/RecentlyModel");
const TreeItemModel = require("../../../../appModel/Tree/TreeItemModel")
const path = require("path")
const SortUtil = require("@/appUtils/SortUtil")

class TreeViewModel {
  constructor(projectId, userSub, tenantId = null){
    this.tenantId = tenantId
    this.projectId = projectId
    this.userSub = userSub
    this.treeItems = []
    this.isNew = true
    this.nodeData = null
    this.treeData = null
    // this.parentNode = parentNode
  }
  async getNewNode(parentNode) {
    try {
      this.isNew = true
      this.nodeData = await TreeItemModel.getNewData(this.projectId)
      this.nodeData.lsiStr1 = parentNode.sk
      this.nodeData.lsiInt1 = parentNode.lsiInt1 + 1 //this.nodeData.sk.split("#").length - 2
    } catch (e) {
      console.log(JSON.stringify(e))
      throw e
    }
  }

  async getEditNode(sk) {
    try {
      this.isNew = false
      this.nodeData = await TreeItemModel.get(sk)
    } catch (e) {
      console.log(JSON.stringify(e))
      throw e
    }
  }
  
  async save() {
    try {
      if (this.isNew) {
        await TreeItemModel.add(this.nodeData)
      } else {
        await TreeItemModel.update(this.nodeData)
      } 
    } catch (e) {
      console.log(JSON.stringify(e))
      throw e
    }
  }

  async update() {
    try {
      await TreeItemModel.update(this.nodeData)
    } catch (e) {
      console.log(JSON.stringify(e))
      throw e
    }
  }
  async delete() {
    try {
      await TreeItemModel.delete(this.nodeData)

      // 最近使用したファイルからも削除
      const recentlyList = await RecentlyModel.list(this.projectId, this.userSub, this.tenantId)
      const targetSk = this.nodeData.sk
      let recently = recentlyList.filter(item => {
        return item.recently.targetSk = targetSk
      })
      if (recently.length > 0) {
        await RecentlyModel.delete(recently[0])
      }
      
    } catch (e) {
      console.log(JSON.stringify(e))
      throw e
    }
  }
  /**
   * フォルダ内での名称重複チェック
   * @param {*} node 
   * @returns true: OK, false: NG(重複あり)
   */
  async duplicationCheck(newLabel) {

    let parent = this.nodeData.lsiStr1
    let sk = this.nodeData.sk
    // let label = node.label
    let treeItems = await TreeItemModel.listLsiStr1(parent)
    treeItems = treeItems.filter(function(item) {
      return item.lsiStr1 == parent && item.treeItem.label == newLabel && item.sk != sk
    }.bind(this))
    console.log(`duplicationCheck ${treeItems.length}件`)
    return treeItems.length == 0
  }
  
  
  /**
   * ツリーデータの作成
   */
  async getTreeData(){
    const sk = TreeItemModel.createSk(this.projectId)
    // ツリーのルートノード
    this.treeData = {
      label: "",
      id: `${this.projectId}`,
      sk: `${sk}`,
      path: "",
      fileSize: "",
      type: "project",
      lsiInt1: 0,
      lstStr1: "",
      treePlace: "",
      children: [],
    }
    
    const treeItems = await TreeItemModel.list(sk)
    
    let itemStore = {}
    treeItems.forEach(function(item){
      
      let parentSk = item.lsiStr1
      // ディープコピーして親ノードキー単位で保持
      if (!itemStore[parentSk]) {
        itemStore[parentSk] = []
      }
      
      item.treeItem.sk = item.sk
      let tmp = JSON.parse(JSON.stringify(item.treeItem))
      tmp.lsiInt1 = item.lsiInt1
      tmp.lsiStr1 = item.lsiStr1
      itemStore[parentSk].push(tmp)
      
    }.bind(this))

    // ルートから再帰呼び出しにより子要素をセットしていく
    await this.appendChildNode(this.treeData, itemStore)
  }
  /**
   * 子ノードの追加（再帰呼び出し）
   * @param {*} node 
   * @param {*} itemStore 
   * @returns 
   */
  async appendChildNode(node, itemStore) {
    // 自分を親とする子ノードを確保
    let child = itemStore[node.sk]
    if (!child) {
      return
    }

    // 追加するノードを並び替え
    let linedList = []
    try {
      let fileList = await SortUtil.sort(child.filter(item => {return item.type == "file"}), "label", "ascending", true);
      let folderList = await SortUtil.sort(child.filter(item => {return item.type == "folder"}), "label", "ascending", true);
      let backImageList = await SortUtil.sort(child.filter(item => {return item.type == "backimage"}), "label", "ascending", true);
      let mapList = await SortUtil.sort(child.filter(item => {return item.type == "map"}), "label", "ascending", true);
      let nobackimageList = await SortUtil.sort(child.filter(item => {return item.type == "nobackimage"}), "label", "ascending", true);
      
      folderList.forEach(item => {
        linedList.push(item)
      })
      backImageList.forEach(item => {
        linedList.push(item)
      })
      mapList.forEach(item => {
        linedList.push(item)
      })
      nobackimageList.forEach(item => {
        linedList.push(item)
      })
      fileList.forEach(item => {
        linedList.push(item)
      })
    } catch (e) {
      console.log(`appendChildNode${e}`)
      throw e
    }
    
    let promiseList = []
    // node.children = JSON.parse(JSON.stringify(child))
    node.children = JSON.parse(JSON.stringify(linedList))
    for (let i = 0;i < node.children.length;i++) {
      let childNode = node.children[i]
      childNode.treePlace = path.join(node.treePlace, node.label)
      // 子ノード毎で非同期に再帰呼び出し
      promiseList.push(this.appendChildNode(childNode, itemStore))
    }
    Promise.all(promiseList)
  }
  async getInspectPlaceList(nodeId) {
    const placeList = await InspectPlaceModel.getInspectPlaceList(this.projectId, nodeId, this.tenantId)
    return placeList
  }
  async hasInspectPlace(nodeId) {
    const placeList = await this.getInspectPlaceList(nodeId)
    return placeList.length > 0
  }
}
module.exports = TreeViewModel;